import GreeksBanner from './GreeksBanner';
import GreeksSection from './GreeksSection';

function Greeks() {
  return (
    <div>
      <GreeksBanner />
      <GreeksSection />
    </div>
  );
}

export default Greeks;